import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { useParams, useLocation } from 'react-router-dom';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import BronzeNugget from '../icons/nuggets/bronze-nugget.svg';
import GoldNugget from '../icons/nuggets/gold-nugget.svg';
import SilverNugget from '../icons/nuggets/silver-nugget.svg';

const FullPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

const PageWrapper = styled.div`
    width: 100%;
    padding-left: 75px;
    padding-right: 75px;
    padding-top: 3rem;
    padding-bottom: 4rem;
    box-sizing: border-box;
`;

const DepartmentTitle = styled.h1`
    font-family: 'Noto Sans', sans-serif;
    font-size: 35px;
    font-weight: 700;
    color: black;
    margin-bottom: 1rem;
`;

const SectionHeader = styled.h2`
    font-family: 'Noto Sans', sans-serif;
    font-size: 35px;
    font-weight: 600;
    color: #27304d;
    margin-bottom: 1rem;
`;

const ItemName = styled(List.Item)`
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #0072ce;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

const TwoColumnLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 4rem;
    column-gap: 150px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const NuggetIcon = styled.span`
    margin-left: 10px;
    font-size: 18px;
`;

export default function DepartmentInfoPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const { departmentId } = useParams();
    const location = useLocation();
    const deptCodeFromState = location.state?.department_code || '';
    const [departmentName, setDepartmentName] = useState('');
    const [departmentCode, setDepartmentCode] = useState(deptCodeFromState);
    const [courses, setCourses] = useState([]);
    const [professors, setProfessors] = useState([]);
    const renderNugget = (nuggetValue) => {
        let src = null;

        switch (nuggetValue) {
            case 1:
                src = BronzeNugget;
                break;
            case 2:
                src = SilverNugget;
                break;
            case 3:
                src = GoldNugget;
                break;
            default:
                return null;
        }

        return (
            <img
                src={src}
                alt="Nugget"
                style={{
                    marginLeft: '10px',
                    height: '18px',
                    verticalAlign: 'middle',
                }}
            />
        );
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_GATEWAY_URL}api/departments/all`)
            .then((r) => r.json())
            .then((data) => {
                const dept = data.find(
                    (d) => d.department_id === parseInt(departmentId),
                );
                if (dept) setDepartmentName(dept.name);
                if (dept) setDepartmentCode(dept.department_code);
            });

        fetch(
            `${process.env.REACT_APP_GATEWAY_URL}api/departments/${departmentId}/courses`,
        )
            .then((r) => r.json())
            .then(setCourses);

        fetch(
            `${process.env.REACT_APP_GATEWAY_URL}api/departments/${departmentId}/professors`,
        )
            .then((r) => r.json())
            .then(setProfessors);
    }, [departmentId]);

    return (
        <FullPageWrapper>
            <Navbar />
            <PageWrapper style={{ flex: 1 }}>
                <DepartmentTitle>
                    {departmentName}{' '}
                    {departmentCode ? `(${departmentCode})` : ''}
                </DepartmentTitle>

                <div
                    style={{
                        borderBottom: '2px solid #8F8F8F',
                        marginTop: '2.5rem',
                        marginBottom: '3rem',
                    }}
                />

                <TwoColumnLayout>
                    <div>
                        <SectionHeader>Courses</SectionHeader>
                        <List relaxed style={{ marginTop: '1.5rem' }}>
                            {[...courses]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((course) => (
                                    <ItemName key={course.course_id}>
                                        <Link
                                            to={`/course/${course.course_id}`}
                                            style={{
                                                color: '#0072CE',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {course.course_code
                                                ? `[${course.course_code}] `
                                                : ''}
                                            {course.name}
                                        </Link>
                                    </ItemName>
                                ))}
                        </List>
                    </div>

                    <div>
                        <SectionHeader>Professors</SectionHeader>
                        <List relaxed style={{ marginTop: '1.5rem' }}>
                            {[...professors]
                                .sort((a, b) =>
                                    `${a.first_name} ${a.last_name}`.localeCompare(
                                        `${b.first_name} ${b.last_name}`,
                                    ),
                                )
                                .map((prof) => (
                                    <ItemName key={prof.professor_id}>
                                        <Link
                                            to={`/professor/${prof.professor_id}`}
                                            style={{
                                                color: '#0072CE',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {prof.first_name} {prof.last_name}
                                        </Link>
                                        {renderNugget(prof.nugget)}
                                    </ItemName>
                                ))}
                        </List>
                    </div>
                </TwoColumnLayout>
            </PageWrapper>
            <Footer />
        </FullPageWrapper>
    );
}
